// Mapping of Countries to Continents/Regions
// This list covers the most common countries in Radio Browser
const REGION_MAP: Record<string, string> = {
  // Europe
  Albania: "Europe",
  Andorra: "Europe",
  Austria: "Europe",
  Belarus: "Europe",
  Belgium: "Europe",
  "Bosnia and Herzegovina": "Europe",
  Bulgaria: "Europe",
  Croatia: "Europe",
  Cyprus: "Europe",
  Czechia: "Europe",
  Denmark: "Europe",
  Estonia: "Europe",
  Finland: "Europe",
  France: "Europe",
  Germany: "Europe",
  Greece: "Europe",
  Hungary: "Europe",
  Iceland: "Europe",
  Ireland: "Europe",
  Italy: "Europe",
  Latvia: "Europe",
  Liechtenstein: "Europe",
  Lithuania: "Europe",
  Luxembourg: "Europe",
  Malta: "Europe",
  Moldova: "Europe",
  Monaco: "Europe",
  Montenegro: "Europe",
  Netherlands: "Europe",
  "North Macedonia": "Europe",
  Norway: "Europe",
  Poland: "Europe",
  Portugal: "Europe",
  Romania: "Europe",
  Russia: "Europe",
  "San Marino": "Europe",
  Serbia: "Europe",
  Slovakia: "Europe",
  Slovenia: "Europe",
  Spain: "Europe",
  Sweden: "Europe",
  Switzerland: "Europe",
  Ukraine: "Europe",
  "United Kingdom": "Europe",
  "Vatican City": "Europe",

  // Americas (North & South)
  Argentina: "Americas",
  Bolivia: "Americas",
  Brazil: "Americas",
  Canada: "Americas",
  Chile: "Americas",
  Colombia: "Americas",
  "Costa Rica": "Americas",
  Cuba: "Americas",
  "Dominican Republic": "Americas",
  Ecuador: "Americas",
  "El Salvador": "Americas",
  Guatemala: "Americas",
  Haiti: "Americas",
  Honduras: "Americas",
  Jamaica: "Americas",
  Mexico: "Americas",
  Nicaragua: "Americas",
  Panama: "Americas",
  Paraguay: "Americas",
  Peru: "Americas",
  "United States": "Americas",
  "The United States Of America": "Americas",
  Uruguay: "Americas",
  Venezuela: "Americas",

  // Asia
  Afghanistan: "Asia",
  Armenia: "Asia",
  Azerbaijan: "Asia",
  Bahrain: "Asia",
  Bangladesh: "Asia",
  Bhutan: "Asia",
  Cambodia: "Asia",
  China: "Asia",
  Georgia: "Asia",
  India: "Asia",
  Indonesia: "Asia",
  Iran: "Asia",
  Iraq: "Asia",
  Israel: "Asia",
  Japan: "Asia",
  Jordan: "Asia",
  Kazakhstan: "Asia",
  Kuwait: "Asia",
  Kyrgyzstan: "Asia",
  Laos: "Asia",
  Lebanon: "Asia",
  Malaysia: "Asia",
  Maldives: "Asia",
  Mongolia: "Asia",
  Myanmar: "Asia",
  Nepal: "Asia",
  "North Korea": "Asia",
  Oman: "Asia",
  Pakistan: "Asia",
  Philippines: "Asia",
  Qatar: "Asia",
  "Saudi Arabia": "Asia",
  Singapore: "Asia",
  "South Korea": "Asia",
  "Sri Lanka": "Asia",
  Syria: "Asia",
  Taiwan: "Asia",
  Tajikistan: "Asia",
  Thailand: "Asia",
  Turkey: "Asia",
  Turkmenistan: "Asia",
  "United Arab Emirates": "Asia",
  Uzbekistan: "Asia",
  Vietnam: "Asia",
  Yemen: "Asia",

  // Africa
  Algeria: "Africa",
  Angola: "Africa",
  Benin: "Africa",
  Botswana: "Africa",
  "Burkina Faso": "Africa",
  Burundi: "Africa",
  Cameroon: "Africa",
  "Cape Verde": "Africa",
  "Central African Republic": "Africa",
  Chad: "Africa",
  Comoros: "Africa",
  Congo: "Africa",
  Djibouti: "Africa",
  Egypt: "Africa",
  "Equatorial Guinea": "Africa",
  Eritrea: "Africa",
  Eswatini: "Africa",
  Ethiopia: "Africa",
  Gabon: "Africa",
  Gambia: "Africa",
  Ghana: "Africa",
  Guinea: "Africa",
  "Ivory Coast": "Africa",
  Kenya: "Africa",
  Lesotho: "Africa",
  Liberia: "Africa",
  Libya: "Africa",
  Madagascar: "Africa",
  Malawi: "Africa",
  Mali: "Africa",
  Mauritania: "Africa",
  Mauritius: "Africa",
  Morocco: "Africa",
  Mozambique: "Africa",
  Namibia: "Africa",
  Niger: "Africa",
  Nigeria: "Africa",
  Rwanda: "Africa",
  Senegal: "Africa",
  Seychelles: "Africa",
  "Sierra Leone": "Africa",
  Somalia: "Africa",
  "South Africa": "Africa",
  "South Sudan": "Africa",
  Sudan: "Africa",
  Tanzania: "Africa",
  Togo: "Africa",
  Tunisia: "Africa",
  Uganda: "Africa",
  Zambia: "Africa",
  Zimbabwe: "Africa",

  // Oceania
  Australia: "Oceania",
  Fiji: "Oceania",
  Kiribati: "Oceania",
  "Marshall Islands": "Oceania",
  Micronesia: "Oceania",
  Nauru: "Oceania",
  "New Zealand": "Oceania",
  Palau: "Oceania",
  "Papua New Guinea": "Oceania",
  Samoa: "Oceania",
  "Solomon Islands": "Oceania",
  Tonga: "Oceania",
  Tuvalu: "Oceania",
  Vanuatu: "Oceania",
};

export const getUserRegion = (): string => {
  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!timeZone) return "Worldwide";

    const prefix = timeZone.split("/")[0];

    // Map Timezone prefixes to our Region Keys
    switch (prefix) {
      case "Europe":
        return "Europe";
      case "Africa":
        return "Africa";
      case "Asia":
        return "Asia";
      case "Australia":
      case "Pacific":
        return "Oceania";
      case "America":
      case "US":
      case "Canada":
      case "Brazil":
      case "Mexico":
      case "Chile":
        return "Americas";
      case "Atlantic":
      case "Indian":
        // Rough heuristics
        return "Worldwide";
      default:
        return "Worldwide";
    }
  } catch (_e) {
    return "Worldwide";
  }
};

export const getRegionForCountry = (country: string): string => {
  return REGION_MAP[country] || "Worldwide";
};

export const getCountryFromCoordinates = async (
  lat: number,
  lon: number,
): Promise<string | null> => {
  try {
    // BigDataCloud Free Reverse Geocoding API (Client-side friendly, no key needed for basic usage)
    const baseUrl =
      import.meta.env.VITE_GEOCODING_API_URL ||
      "https://api.bigdatacloud.net/data/reverse-geocode-client";
    const response = await fetch(
      `${baseUrl}?latitude=${lat}&longitude=${lon}&localityLanguage=en`,
    );

    if (!response.ok) throw new Error("Geocoding failed");

    const data = await response.json();
    return data.countryName || null;
  } catch (error) {
    console.error("Reverse Geocoding Error:", error);
    return null;
  }
};
